export const NOK = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#clip0_2493_12292)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#EEEEEE"
      />
      <path
        d="M0.412598 15.1313C1.10249 17.6714 2.60779 19.9146 4.69697 21.5157V15.1313H0.412598ZM10.9595 23.9532C11.3055 23.9837 11.6527 23.9993 12.0001 24C14.6378 24.0008 17.2022 23.1324 19.2967 21.5293C21.3913 19.9261 22.8993 17.6776 23.5876 15.1313H10.9548V23.9532H10.9595ZM23.5876 8.86879C22.8523 6.1494 21.1837 3.77538 18.8741 2.1625C16.5645 0.549621 13.761 -0.199295 10.9548 0.0469152V8.86879H23.5876ZM4.69697 2.48442C2.60779 4.08552 1.10249 6.32866 0.412598 8.86879H4.69697V2.48442Z"
        fill="#D80027"
      />
      <path
        d="M23.8969 10.4343H9.38909V0.285889C8.29709 0.527894 7.24458 0.922388 6.26253 1.45776V10.4343H0.103154C-0.0324317 11.4737 -0.0324317 12.5262 0.103154 13.5656H6.26253V22.5421C7.24458 23.0775 8.29709 23.472 9.38909 23.714V13.5656H23.8969C24.0323 12.5262 24.0323 11.4737 23.8969 10.4343Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_2493_12292">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
